import { render, staticRenderFns } from "./WarrantyClaimHeader.vue?vue&type=template&id=181594a6&"
import script from "./WarrantyClaimHeader.vue?vue&type=script&lang=js&"
export * from "./WarrantyClaimHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports